import { CountryActionTypes } from "./constants";
import {
  COUNTRIES,
  getCountryByCode,
  DEFAULT_COUNTRY_CODE,
} from "./countries";
import { APICore } from "../../helpers/api/apiCore";

const api = new APICore();
const isAuthenticated = api.isUserAuthenticated();
const loggedInUser = api.getLoggedInUser();
const savedCountry = JSON.parse(localStorage.getItem("country") || "null");

const initialState = savedCountry
  ? savedCountry
  : (() => {
      if (isAuthenticated) {
        const userCountry = loggedInUser.country;
        const initialCountry =
          (userCountry && getCountryByCode(userCountry)) ?? COUNTRIES[0];
        return {
          code: initialCountry.code,
          name: initialCountry.name,
          flag: initialCountry.flag,
        };
      }
      const defaultCountry =
        getCountryByCode(DEFAULT_COUNTRY_CODE) ?? COUNTRIES[0];
      return {
        code: defaultCountry.code,
        name: defaultCountry.name,
        flag: defaultCountry.flag,
      };
    })();

const countryReducer = (state = initialState, action: { type: string; payload?: { code: string; name: string; flag: string } }) => {
  switch (action.type) {
    case CountryActionTypes.UPDATE_COUNTRY:
      return action.payload
        ? {
            ...state,
            code: action.payload.code,
            name: action.payload.name,
            flag: action.payload.flag,
          }
        : state;
    default:
      return { ...state };
  }
};

export default countryReducer;
